import * as tslib_1 from "tslib";
import { BaseApiClient } from './BaseApiClient';
export var LEAGUES_ENDPOINTS = {
    BY_SPORT_ID: '/Leagues/GetBySportId',
    TOP_LEAGUES_BY_SPORT_ID: '/Leagues/GetTopLeaguesBySportId',
    LEAGUES_BY_LEAGUE_IDS: '/Leagues/GetByLeagueId'
};
/**
 * LeaguesApiClient - client for fetching Leagues BFF endpoints
 * @export
 * @class LeaguesApiClient
 * @extends {BaseApiClient}
 */
var LeaguesApiClient = /** @class */ (function (_super) {
    tslib_1.__extends(LeaguesApiClient, _super);
    function LeaguesApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetch all leagues by sport id from BFF
     * @param {request} LeaguesBySportIdRequest
     * @throws {RequiredError}
     * @memberof LeaguesApiClient
     */
    LeaguesApiClient.prototype.getBySportId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(LEAGUES_ENDPOINTS.BY_SPORT_ID, fetchOptions);
    };
    /**
     * Fetch all top leagues by sport id from BFF
     * @param {request} TopLeaguesBySportIdRequest
     * @throws {RequiredError}
     * @memberof LeaguesApiClient
     */
    LeaguesApiClient.prototype.getTopLeaguesBySportId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(LEAGUES_ENDPOINTS.TOP_LEAGUES_BY_SPORT_ID, fetchOptions);
    };
    /**
    * Fetch all leagues by LeagueId
    * @param {request} LeaguesByLeagueIdRequest
    * @throws {RequiredError}
    * @memberof LeaguesApiClient
    */
    LeaguesApiClient.prototype.getLeaguesByLeagueId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(LEAGUES_ENDPOINTS.LEAGUES_BY_LEAGUE_IDS, fetchOptions);
    };
    return LeaguesApiClient;
}(BaseApiClient));
export { LeaguesApiClient };
//# sourceMappingURL=LeaguesApiClient.js.map